import { useState } from "react";
import { X } from "@phosphor-icons/react";
import { toast } from "sonner";

export const StockBadge = ({ stock, min, testId }) => {
  const cls = stock <= 0 ? "bg-red-100 text-red-700"
    : min > 0 && stock < min ? "bg-amber-100 text-amber-700"
    : "bg-emerald-100 text-emerald-700";
  return (
    <span data-testid={testId} title={min > 0 && stock < min ? `Below minimum level (${min})` : undefined}
      className={`inline-block rounded-full px-2.5 py-0.5 font-mono text-xs font-semibold ${cls}`}>
      {stock}
    </span>
  );
};

export const MinCell = ({ value, onSave, testId }) => {
  const [editing, setEditing] = useState(false);
  const [val, setVal] = useState(value);
  if (!editing) {
    return (
      <button data-testid={testId} onClick={() => { setVal(value); setEditing(true); }}
        title="Click to set minimum stock level"
        className="rounded-md px-2 py-0.5 font-mono text-xs text-slate-500 underline decoration-dotted underline-offset-2 hover:bg-slate-100">
        {value > 0 ? value : "set"}
      </button>
    );
  }
  const save = () => {
    const v = parseFloat(val);
    if (isNaN(v) || v < 0) return;
    onSave(v);
    setEditing(false);
  };
  return (
    <input type="number" min="0" step="any" autoFocus value={val} data-testid={`${testId}-input`}
      onChange={(e) => setVal(e.target.value)} onBlur={save}
      onKeyDown={(e) => { if (e.key === "Enter") save(); if (e.key === "Escape") setEditing(false); }}
      className="w-20 rounded-md border border-slate-300 px-2 py-1 text-xs outline-none focus:border-slate-900" />
  );
};

export const StockInForm = ({ onSubmit, onCancel, testId }) => {
  const [qty, setQty] = useState("");
  const [note, setNote] = useState("");
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={`${testId}-form`}>
      <input type="number" min="0.001" step="any" value={qty} onChange={(e) => setQty(e.target.value)}
        placeholder="Qty" autoFocus data-testid={`${testId}-qty`}
        className="w-24 rounded-md border border-slate-300 px-2 py-1.5 text-sm outline-none focus:border-slate-900" />
      <input value={note} onChange={(e) => setNote(e.target.value)} placeholder="Note (optional)"
        data-testid={`${testId}-note`}
        className="w-36 rounded-md border border-slate-300 px-2 py-1.5 text-sm outline-none focus:border-slate-900" />
      <button data-testid={`${testId}-confirm`}
        onClick={() => { const q = parseFloat(qty); if (!q || q <= 0) { toast.error("Enter a valid quantity"); return; } onSubmit(q, note); }}
        className="rounded-md bg-slate-900 px-3 py-1.5 text-xs font-semibold text-white transition-colors duration-150 hover:bg-slate-700">
        Add
      </button>
      <button onClick={onCancel} className="p-1 text-slate-400 hover:text-slate-600"><X size={14} /></button>
    </div>
  );
};

export const AdjustStockForm = ({ current, onSubmit, onCancel, testId }) => {
  const [val, setVal] = useState(current);
  const [note, setNote] = useState("");
  return (
    <div className="flex flex-wrap items-center justify-end gap-2" data-testid={`${testId}-form`}>
      <input type="number" min="0" step="any" value={val} autoFocus data-testid={`${testId}-value`}
        onChange={(e) => setVal(e.target.value)}
        className="w-24 rounded-md border border-slate-300 px-2 py-1.5 text-sm outline-none focus:border-slate-900" />
      <input value={note} onChange={(e) => setNote(e.target.value)} placeholder="Reason (optional)"
        data-testid={`${testId}-note`}
        className="w-36 rounded-md border border-slate-300 px-2 py-1.5 text-sm outline-none focus:border-slate-900" />
      <button data-testid={`${testId}-confirm`}
        onClick={() => { const v = parseFloat(val); if (isNaN(v) || v < 0) { toast.error("Enter a valid stock value"); return; } onSubmit(v, note); }}
        className="rounded-md bg-slate-900 px-3 py-1.5 text-xs font-semibold text-white transition-colors duration-150 hover:bg-slate-700">
        Save
      </button>
      <button onClick={onCancel} className="p-1 text-slate-400 hover:text-slate-600"><X size={14} /></button>
    </div>
  );
};
